"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeltdownEffectHandler = exports.MeltdownEffectArgs = void 0;
const _1 = require(".");
const __1 = require("../../..");
const Duration_1 = require("../../Duration");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class MeltdownEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Meltdown;
        this.__typeName = "Meltdown";
        this.name = "Meltdown";
        this.harmful = true;
    }
}
exports.MeltdownEffectArgs = MeltdownEffectArgs;
let MeltdownEffectHandler = class MeltdownEffectHandler {
    apply(sequence, container, state) {
        state.meta.healingDecreaseEffectId = container.applyDebuff({
            sequence,
            attackerId: state.creatorId,
            targetId: state.targetId,
            effect: new _1.MaxAttributeIncreaseEffectArgs(__1.AttributeType.PercentHealingReceivedDecrease, 100),
            duration: Duration_1.Duration.Permanent,
            supernatural: true,
        });
        state.meta.applyHealingEventHandlerId = container.registerEventHandler(state.targetId, EventType_1.EventType.EffectApplied, Schedule_1.Schedule.Unlimited, new __1.CustomScriptEventHandlerArgs("Effect_Meltdown_OnHealingEffectApplied", {
            attackerId: state.creatorId
        }));
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.healingDecreaseEffectId);
        container.cancelEventHandler(state.meta.applyHealingEventHandlerId);
    }
};
MeltdownEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Meltdown)
], MeltdownEffectHandler);
exports.MeltdownEffectHandler = MeltdownEffectHandler;
